/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiPaymentsListSortBy = typeof GetApiPaymentsListSortBy[keyof typeof GetApiPaymentsListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiPaymentsListSortBy = {
  createdAt: 'createdAt',
  paidAt: 'paidAt',
  amount: 'amount',
  status: 'status',
  type: 'type',
} as const;
